import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function RecentStrategicCustomerWins({ recentStrategicCustomerWins }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     customers: "b",
  //     segments: "c",
  //     deal_summary: "d",
  //     years: "e",
  //     customers_positive_insight: "b",
  //     customers_negative_insight: "b",
  //     customers_recent_development: "b",
  //     segments_positive_insight: "c",
  //     segments_negative_insight: "c",
  //     segments_recent_development: "c",
  //     deal_summary_positive_insight: "d",
  //     deal_summary_negative_insight: "d",
  //     deal_summary_recent_development: "d",
  //     years_positive_insight: "e",
  //     years_negative_insight: "e",
  //     years_recent_development: "e",
  //   },
  //   {
  //     competitor: "a",
  //     customers: "b",
  //     segments: "c",
  //     deal_summary: "d",
  //     years: "e",
  //     customers_positive_insight: "b",
  //     customers_negative_insight: "b",
  //     customers_recent_development: "b",
  //     segments_positive_insight: "c",
  //     segments_negative_insight: "c",
  //     segments_recent_development: "c",
  //     deal_summary_positive_insight: "d",
  //     deal_summary_negative_insight: "d",
  //     deal_summary_recent_development: "d",
  //     years_positive_insight: "e",
  //     years_negative_insight: "e",
  //     years_recent_development: "e",
  //   },
  //   {
  //     competitor: "a",
  //     customers: "b",
  //     segments: "c",
  //     deal_summary: "d",
  //     years: "e",
  //     customers_positive_insight: "b",
  //     customers_negative_insight: "b",
  //     customers_recent_development: "b",
  //     segments_positive_insight: "c",
  //     segments_negative_insight: "c",
  //     segments_recent_development: "c",
  //     deal_summary_positive_insight: "d",
  //     deal_summary_negative_insight: "d",
  //     deal_summary_recent_development: "d",
  //     years_positive_insight: "e",
  //     years_negative_insight: "e",
  //     years_recent_development: "e",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(recentStrategicCustomerWins);
    setTabData(tableData);
  }, [recentStrategicCustomerWins]);

  // Columns for GenericTable
  const tableColumns = [
    { key: "customers", label: "Customers" },
    { key: "segments", label: "Segments" },
    { key: "deal_summary", label: "Deal Summary" },
    { key: "years", label: "Years", width: "100px" },
  ];

  return (
    <InsightTable
      title="Recent Strategic Customer Wins"
      subtitle="Compare high-impact customer acquisitions across competitors to identify where traction is growing or white-space risk exists."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default RecentStrategicCustomerWins;
